<template>
	<div>
		<vs-button
			class="font-bold"
			color="primary"
			icon-pack="feather"
			icon="icon-list"
			size="small"
			type="flat"
			@click.prevent="popupVehicle = true"
			><small style="font-size: 13px">{{ $t("Select") }}</small>
		</vs-button>
		<vs-popup class="SelectVehicle" :title="$t('Vehicles.Vehicles')" :active.sync="popupVehicle">
			<vs-row>
				<vs-col class="flex justify-between" vs-w="12">
					<h4>{{ $t("Vehicles.AssigneVehicleText") }}</h4>
					<vs-dropdown
						v-if="selected.length > 0"
						vs-custom-content
						vs-trigger-click
						class="cursor-pointer"
						:title="$t('ResourceModule.MassiveActionsResource')"
					>
						<vs-button icon-pack="feather" icon="icon-settings">
							<vs-icon class="" icon="expand_more"></vs-icon>
						</vs-button>
						<vs-dropdown-menu style="z-index: 54000; width: 350px">
							<div class="p-2">
								<h6>{{ $t("Crud.Update") + " " + $t("Vehicles.Vehicles") }}</h6>
								<div class="vx-row">
									<div class="vx-col md:w-2/3 w-full">
										<vs-input
											v-model="amount"
											class="w-full mb-2"
											type="number"
											ref="inputDemand"
											@keydown="onKeyDown($event)"
										/>
									</div>
									<div class="vx-col md:w-1/3 w-full">
										<vs-button
											class="float-right"
											width="100%"
											color="success"
											type="border"
											@click.prevent="updateSelectedCosts(amount)"
										>
											{{ $t("Apply") }}
										</vs-button>
									</div>
								</div>
							</div>
						</vs-dropdown-menu>
					</vs-dropdown>
				</vs-col>
				<vs-col vs-w="12" id="div-with-loading" class="vs-con-loading__container">
					<vs-table
						v-model="selected"
						multiple
						pagination
						max-items="10"
						search
						:key="updateComponent"
						:data="tempVehicles"
					>
						<div slot="header" class="flex flex-reverse items-center flex-grow justify-between">
							<vs-button @click="saveSourceList()">
								{{ $t("Select") }}
							</vs-button>
						</div>
						<template slot="thead">
							<vs-th>{{ $t("Identification") }}</vs-th>
							<vs-th>{{ $t("Cost") }}</vs-th>
						</template>
						<template slot-scope="{data}">
							<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
								<vs-td :data="data[indextr]">
									{{ data[indextr].identification }}
								</vs-td>
								<vs-td :data="data[indextr]">
									<vs-input
										v-model="data[indextr].cost"
										type="number"
										ref="inputDemand"
										@keydown="onKeyDown($event, data[indextr])"
									/>
								</vs-td>
							</vs-tr>
						</template>
					</vs-table>
				</vs-col>
			</vs-row>
		</vs-popup>
	</div>
</template>

<script>
import {generalPurposeMixin} from "@/mixins/generalPurposeMixin.js";
export default {
	name: "JobSelectVehicle",
	mixins: [generalPurposeMixin],
	data() {
		return {
			popupVehicle: false,
			amount: 0,
			selected: [],
			updateComponent: 1,
		};
	},
	props: {
		// Función para devolver el listado de recursos seleccionados.
		addVehicle: Function,
		// Función para eliminar un elemento del array.
		deleteVehicle: Function,
	},
	computed: {
		vehicleList() {
			return this.$store.state.moduleOptimization.standardInputList["vehicles"] === undefined ||
				this.$store.state.moduleOptimization.standardInputList["vehicles"] === "" ||
				this.$store.state.moduleOptimization.standardInputList["vehicles"] === null
				? []
				: this.$store.state.moduleOptimization.standardInputList["vehicles"];
		},
		tempVehicles() {
			return this.vehicleList.map((vehicle) => ({...vehicle, cost: 0}));
		},
	},
	watch: {
		tempVehicles(newval) {
			if (newval.length > 0) {
				this.$vs.loading.close("#div-with-loading > .con-vs-loading");
			}
		},
		popupVehicle(val) {
			if (val) {
				this.tempVehicles.map((data) => (data.cost = 0));
				this.selected = [];
				this.amount = 0;
			}
		},
	},
	methods: {
		saveSourceList() {
			// Hacemos una copía del array, ya que los datos los estamos trayendo directamente desde el store y generará error si modificamos algo
			const copy = this.selected.map((b, idx) => Object.assign({index: idx}, b));
			this.addVehicle(copy, this.selected);
			this.popupVehicle = false;
		},
		updateSelectedCosts(value) {
			if (this.tempVehicles.length > 0) {
				this.tempVehicles.forEach((vehicle) => {
					this.selected.forEach((item) => {
						if (vehicle.identification === item.identification) item.cost = value;
					});
				});
				this.updateComponent++;
			}
		},
	},
	mounted() {
		if (this.tempVehicles.length < 0) {
			this.$vs.loading({
				container: "#div-with-loading",
				scale: 1,
				type: "sound",
			});
		}
	},
};
</script>
